import { render } from "./NewsContent.vue?vue&type=template&id=89d45000&scoped=true"
import script from "./NewsContent.vue?vue&type=script&lang=js"
export * from "./NewsContent.vue?vue&type=script&lang=js"

import "./NewsContent.vue?vue&type=style&index=0&id=89d45000&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89d45000"]])

export default __exports__